import React, { createElement, Fragment } from "react";
import { Helmet } from "react-helmet";

import { Applications } from "ducks/Applications/index";

export default function ApplicationsPage(props) {
  return (
    <Fragment>
      <Helmet>
        <title>{"Applications - Savant Power"}</title>
      </Helmet>
      {createElement(Applications, props)}
    </Fragment>
  );
}
